import { upperFirst as uF } from 'lodash-es'

const initials = value => {
  if (!value) return 'S'

  let match = value.match(/[A-Z]/g)
  if (match) return match.join('').substring(0, 2)

  match = value.match(/\b(\w)/)
  if (match) return match.join('').toUpperCase().substring(0, 2)

  return value.charAt(0).toUpperCase().substring(0, 2)
}
const upperFirst = value => uF(value).replace('_', ' ')
const removeUnit = value => {
  if (!value) return ''

  if (value.includes('rem')) {
    return 16 * Number(value.replace('rem', '') || 0)
  }

  if (value.includes('s')) {
    return value.replace('s', '')
  }

  return value.replace('px', '')
}
const addUnit = (value, unit = 'px') => {
  if (!value) return ''

  if (value.includes(unit)) return value

  if (value === 'auto') return value

  return `${value}${unit}`
}
const isNumber = value => !isNaN(Number(value))
const setInputType = value => {
  if (value === '' || value === null) return 'text'

  if (isNumber(parseFloat(value))) return 'number'

  return 'text'
}
const prettyNumber = value => {
  try {
    const formatter = new Intl.NumberFormat()
    return formatter.format(value)
  } catch (e) {
    return value
  }
}

const filters = {
  initials,
  upperFirst,
  removeUnit,
  addUnit,
  isNumber,
  setInputType,
  prettyNumber
}

export default {
  filters,
  methods: filters
}
